import { Record as record } from 'immutable';

import { translate as t } from '../../lib/I18n';
import { construct, resolve } from '../../helpers/LinkMapper';
import { SmartcardProductStatus } from '../../constants/AppConstants';

import SmartcardProductParameters from './SmartcardProductParameters';


const defaults = {
	serviceName: null,
    orderId: null,
	reference: null,
	oid: null,
	typ: null,
	ptyp: null,
	status: null,
	serviceBlocked: null,
	parameters: null,
	flexi: null,
};


export const MIN_KEYGO_BALANCE_TO_WITHDRAW = 0;


export default class SmartcardProduct extends record(defaults) {
	static fromJSON (json = {}) {
		return construct(SmartcardProduct, json, {
			serviceName: resolve.with(String),
			reference: resolve.with(String),
            orderId: resolve.with(Number),
			oid: resolve.with(Number),
			typ: resolve.with(Number),
			ptyp: resolve.with(Number),
			status: resolve.with(String),
			serviceBlocked: resolve.with(Boolean),
			parameters: resolve.as(SmartcardProductParameters),
			flexi: resolve.with(Object)
		});
	}

    isActive () {
        return this.status === SmartcardProductStatus.ACTIVE;
    }

    getDescription () {
        const ticketType = t(`itso.typ${ this.typ }.ptyp${ this.ptyp }`);
        return this.parameters.Description || `${t('app.owner.short')} ${ticketType}`;
    }

    getOriginName () {
        return this.parameters.Origin || this.parameters.OriginName;
    }

    getOriginNlc () {
        return this.parameters.originNlc;
    }

    getDestinationName () {
        return this.parameters.Destination || this.parameters.DestinationName;
    }

    getDestinationNlc () {
        return this.parameters.destinationNlc;
    }

    getPrice () {
        return this.parameters.AmountPaid;
    }

    getValidFrom () {
        const validFrom = this.parameters.StartDate || this.parameters.ExpiryDate;
        return validFrom.clone().startOf('day');
    }

    getValidTo () {
        return this.parameters.ExpiryDate && this.parameters.ExpiryDate.clone().endOf('day');
    }

    getOrderDate () {
        return this.parameters.IssueDate;
    }

    isSeason () {
        return this.typ === 22 && this.ptyp === 1;
    }

    isSingle () {
        return this.typ === 23 && [1, 2].includes(this.ptyp);
    }

    isReturn () {
        return this.typ === 23 && [3, 4].includes(this.ptyp);
    }

    isFlexi () {
        return this.typ === 22 && this.ptyp === 5;
    }

    isDaySave () {
        return this.typ === 22 && this.ptyp === 28;
    }

    isTravelCard () {
        return this.typ === 22 && this.ptyp === 19;
    }

    isFirstClass () {
        return this.parameters.Class === 'First' || this.parameters.TravelClass === '1';
    }

    getRoute () {
        const route = this.parameters.RouteName || this.parameters.routeCode;
        // Workaround CMS quirks
        return route && route.match(/\D/) ? route : undefined;
    }

    isKeyGo () {
        return this.typ === 22 && this.ptyp === 4;
    }

    getLastTopupDate () {
        return this.parameters.LAST_TOPUP_DATE;
    }

    getLastTopupAmount () {
        return this.parameters.LAST_TOPUP_AMOUNT;
    }

    hasIncompleteJourneys () {
        return this.parameters.PROVISIONAL_INCOMPLETE_COUNT > 0;
    }

    getPassesRemaining () {
        return this.parameters.NumberRemainingPasses;
    }

    getDateOfLastUsedPass () {
        return this.parameters.dateOfLastUsedPass;
    }

    getExpiryDate () {
        return this.parameters.expiryDateOfPasses;
    }

    getStatus () {
        return this.status;
    }

    getOrderId () {
        return this.orderId;
    }

}
